module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "warp"
  }, [_c('el-col', {
    staticClass: "warp-breadcrum",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('b', [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("项目管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("项目列表")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "warp-main",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "filtersForm",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "项目名称"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('filtersForm')
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('project:add'),
      expression: "'project:add'"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddDialog
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.projectPageDatas,
      "highlight-current-row": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60",
      "align": "center",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "项目名称",
      "width": "180",
      "show-overflow-tooltip": "",
      "fixed": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "项目ID",
      "width": "180",
      "show-overflow-tooltip": "",
      "fixed": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "custName",
      "label": "客户名称",
      "width": "180",
      "show-overflow-tooltip": "",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contact",
      "label": "联系人",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telephone",
      "label": "联系电话",
      "width": "110",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provinceName",
      "label": "省",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "市",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "districtName",
      "label": "区/县",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addressDetail",
      "label": "详细地址",
      "width": "230",
      "show-overflow-tooltip": "",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "创建时间",
      "width": "155",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateDate",
      "label": "更新时间",
      "width": "155",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "260"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "has-permission",
            rawName: "v-has-permission",
            value: ('project:update'),
            expression: "'project:update'"
          }],
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.showEditDialog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "has-permission",
            rawName: "v-has-permission",
            value: ('project:detail'),
            expression: "'project:detail'"
          }],
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.toDetail(scope.row)
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "has-permission",
            rawName: "v-has-permission",
            value: ('project:delete'),
            expression: "'project:delete'"
          }],
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.remove(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-sizes": [10, 20, 50, 100],
      "page-size": 10,
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      },
      "open": _vm.onAddDialogOpen
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "130px",
      "rules": _vm.formRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "maxlength": "30",
      "show-word-limit": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "prop": "orgId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.orgId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "orgId", $$v)
      },
      expression: "addForm.orgId"
    }
  }, _vm._l((_vm.custDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市区",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "provinceCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.addForm.provinceCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "provinceCode", $$v)
      },
      expression: "addForm.provinceCode"
    }
  }, _vm._l((_vm.provinceDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cityCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleCityChange
    },
    model: {
      value: (_vm.addForm.cityCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "cityCode", $$v)
      },
      expression: "addForm.cityCode"
    }
  }, _vm._l((_vm.cityDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "districtCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleDistrictChange
    },
    model: {
      value: (_vm.addForm.districtCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "districtCode", $$v)
      },
      expression: "addForm.districtCode"
    }
  }, _vm._l((_vm.districtDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "addressDetail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "maxlength": "40",
      "show-word-limit": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.addressDetail),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "addressDetail", $$v)
      },
      expression: "addForm.addressDetail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备品类",
      "prop": "deviceCategoryIds"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.deviceCategoryIds),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "deviceCategoryIds", $$v)
      },
      expression: "addForm.deviceCategoryIds"
    }
  }, _vm._l((_vm.deviceCategoryDatas), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "contact"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "maxlength": "10",
      "show-word-limit": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.contact),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "contact", $$v)
      },
      expression: "addForm.contact"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "telephone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "maxlength": "11",
      "show-word-limit": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.telephone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "telephone", $$v)
      },
      expression: "addForm.telephone"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      },
      "open": _vm.onEditDialogOpen
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.formRules
    }
  }, [_c('el-input', {
    attrs: {
      "type": "hidden"
    },
    model: {
      value: (_vm.editForm.id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "id", $$v)
      },
      expression: "editForm.id"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "maxlength": "30",
      "show-word-limit": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "prop": "orgId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.orgId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "orgId", $$v)
      },
      expression: "editForm.orgId"
    }
  }, _vm._l((_vm.custDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市区",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "provinceCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.editForm.provinceCode),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "provinceCode", $$v)
      },
      expression: "editForm.provinceCode"
    }
  }, _vm._l((_vm.provinceDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cityCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleCityChange
    },
    model: {
      value: (_vm.editForm.cityCode),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cityCode", $$v)
      },
      expression: "editForm.cityCode"
    }
  }, _vm._l((_vm.cityDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "districtCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleDistrictChange
    },
    model: {
      value: (_vm.editForm.districtCode),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "districtCode", $$v)
      },
      expression: "editForm.districtCode"
    }
  }, _vm._l((_vm.districtDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "addressDetail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "maxlength": "40",
      "show-word-limit": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.addressDetail),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "addressDetail", $$v)
      },
      expression: "editForm.addressDetail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备品类",
      "prop": "deviceCategoryIds"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleDeviceCategoryChange
    },
    model: {
      value: (_vm.editForm.deviceCategoryIds),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deviceCategoryIds", $$v)
      },
      expression: "editForm.deviceCategoryIds"
    }
  }, _vm._l((_vm.deviceCategoryDatas), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "contact"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "maxlength": "10",
      "show-word-limit": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.contact),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "contact", $$v)
      },
      expression: "editForm.contact"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "telephone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "maxlength": "11",
      "show-word-limit": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.telephone),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "telephone", $$v)
      },
      expression: "editForm.telephone"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f44c028"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/projectList.vue
// module id = 1171
// module chunks = 2